import React from 'react';

interface MobileFooterMenuIconWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const MobileFooterMenuIconWrapper = ({ children, className, ...props }: MobileFooterMenuIconWrapperProps) => {
  return (
    <div className={`flex flex-col items-center gap-2 ${className || ''}`} {...props}>
      {children}
    </div>
  );
};

export default MobileFooterMenuIconWrapper;
